/**
 * Single source of merchant identification for affiliate CTAs. The merchant name is rendered as
 * plain crawlable text beside the link so a visitor always knows which company they are going to
 * before they click. The name comes from the offer record, so any future partner is identified
 * automatically without touching page copy.
 */
export const MerchantNote = ({ merchant, dark = false, testId }) =>
  merchant ? (
    <p
      data-testid={testId}
      className={`text-[12px] mt-3 ${dark ? "text-[#A9A5A0]" : "text-[#6E6A63]"}`}
    >
      Affiliate link · opens at{" "}
      <span className={`font-semibold ${dark ? "text-white" : "text-[#3F3F3F]"}`}>{merchant}</span>
    </p>
  ) : null;

// True when a CTA label already names the merchant, so the note does not repeat it.
export const labelNamesMerchant = (label, merchant) =>
  Boolean(label && merchant) && label.toLowerCase().includes(merchant.toLowerCase());
